// 決算整理仕訳 含む/含まない 切替 (freee /reports/trial_pl|trial_bs の adjustment パラメータ)
//   - freee は adjustment 未指定 = 決算整理仕訳を含む。'without' = 決算整理仕訳以外。
//   - 決算月(9月)は減価償却費の年間精算(見込→台帳確定額)が決算整理仕訳で入るため、
//     月次比較では「含まない」、決算書・年間合計では「含む」で見る使い分けが必要
//     (2025-09 減価償却費 2,312,196 = 通常 1,120,222 + 精算差 1,191,974 の件)。
//   - 決算書ページ / 予算実績ページ共通。選択は localStorage に保持し、既定は従来どおり「含む」。
const KEY = 'freeeman.reports.includeAdjustment.v1';

let includeAdjustment: boolean = (() => {
  try { const v = localStorage.getItem(KEY); return v == null ? true : v === '1'; } catch { return true; }
})();

export function getIncludeAdjustment(): boolean { return includeAdjustment; }

export function setIncludeAdjustment(v: boolean): void {
  includeAdjustment = v;
  try { localStorage.setItem(KEY, v ? '1' : '0'); } catch { /* private mode 等は無視 */ }
}

/** fetch 時に query へ spread する。含む=パラメータ無し(freee 既定)、含まない=adjustment=without */
export function adjustmentQuery(): Record<string, string> {
  return includeAdjustment ? {} : { adjustment: 'without' };
}

/** 帳票ヘッダの注記(実際の取得条件と一致させる) */
export function adjustNoteFor(): string {
  return includeAdjustment
    ? '【整理仕訳の集計条件】振戻仕訳・整理仕訳を集計する'
    : '【整理仕訳の集計条件】振戻仕訳・整理仕訳を集計しない';
}
